<template>
  <v-dialog
    v-model="showDialog"
    persistent
  >
    <v-card :loading="!embeddedSessionCode">
      <v-card-title> Prepare document for signature </v-card-title>
      <div class="preview-body-ctn">
        <iframe
          v-if="embeddedSessionCode"
          id="embeddedSession"
          ref="embeddedSession"
          class="annature-iframe"
          title="Sign"
          :src="prepareDocumentEndpoint"
        />
      </div>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          @click.stop="triggerSave"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const ANNATURE_BASE_URL = 'https://dashboard.annature.com.au'
const SAVE_SUCCESS = 'annatureSaveSuccess'
const SAVE_ERROR = 'annatureSaveError'

export default {
  name: 'PrepareDocumentDialog',
  props: {
    showDialog: { type: Boolean, default: false },
    docData: { type: Object, default: null }
  },
  data: function () {
    return { embeddedSessionCode: null }
  },
  computed: {
    prepareDocumentEndpoint: function () {
      return this.embeddedSessionCode
        ? `${ANNATURE_BASE_URL}/code-exchange?code=${this.embeddedSessionCode}&type=embedded-session`
        : null
    }
  },
  watch: {
    async showDialog(value) {
      if (value) {
        this.startListeningForMessages()
        this.createEmbeddedSession()
      } else {
        this.stopListeningForMessages()
      }
    }
  },
  beforeDestroy() {
    this.stopListeningForMessages()
  },
  methods: {
    startListeningForMessages() {
      window.addEventListener('message', this.handleMessageEvent, {
        passive: true
      })
    },
    stopListeningForMessages() {
      window.removeEventListener('message', this.handleMessageEvent, {
        passive: true
      })
    },
    handleMessageEvent({ data: { event, message } = {} }) {
      switch (event) {
      case SAVE_SUCCESS:
        this.$emit('done')
        break
      case SAVE_ERROR:
        this.$showErrorbar(message)
        break
      }
    },
    async createEmbeddedSession() {
      const { documentId: id } = this.docData
      this.$handlingError('Error creating document for signature preparation', async () => {
        const response = await this.$api.createDocumentPreparationSession({ id })
        this.embeddedSessionCode = response.data.code
      })
    },
    triggerSave() {
      this.$refs.embeddedSession.contentWindow.postMessage('annatureSave', ANNATURE_BASE_URL)
    }
  }
}
</script>

<style lang="scss" scoped>
.preview-body-ctn {
  width: 100%;
  height: 80vh;
  display: flex;

  .annature-iframe {
    height: 100%;
    width: 100%;
  }
}
</style>
